import { render, staticRenderFns } from "./DisclosureModal.vue?vue&type=template&id=55ffba92"
import script from "./DisclosureModal.vue?vue&type=script&lang=js"
export * from "./DisclosureModal.vue?vue&type=script&lang=js"
import style0 from "./DisclosureModal.vue?vue&type=style&index=0&id=55ffba92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports